import React from 'react';
import { Box, Typography } from '@mui/material';
import { motion } from 'framer-motion';
import { AutoAwesome } from '@mui/icons-material';

const tickerItems = [
    "Premium Quality Fabrics",
    "Trendy Designs",
    "Affordable Luxury",
    "Modern Indian Style",
    "Sustainable Fashion",
    "Ethically Sourced"
];

const InfiniteTicker = () => {
    // Duplicate the list once for a seamless loop using percentages
    const doubledItems = [...tickerItems, ...tickerItems];

    return (
        <Box
            sx={{
                backgroundColor: '#1a1a1a',
                py: 2.2, // Balanced padding
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                display: 'flex',
                alignItems: 'center',
            }}
        >
            <Box
                component={motion.div}
                animate={{
                    x: ["0%", "-50%"],
                }}
                transition={{
                    x: {
                        repeat: Infinity,
                        repeatType: "loop",
                        duration: 35, // Slower for readability
                        ease: "linear",
                    },
                }}
                sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '2.5rem', // Slightly wider gap between items
                    flexShrink: 0
                }}
            >
                {doubledItems.map((item, index) => (
                    <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: '1.2rem' }}>
                        {/* Conditional Icon: Sparkle for Premium, Dot for others */}
                        {item === "Premium Quality Fabrics" ? (
                            <AutoAwesome
                                sx={{
                                    color: '#d4a3a3',
                                    fontSize: '1.4rem',
                                    filter: 'drop-shadow(0 0 5px rgba(212,163,163,0.3))'
                                }}
                            />
                        ) : (
                            <Box
                                sx={{
                                    width: 6,
                                    height: 6,
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(212, 163, 163, 0.4)'
                                }}
                            />
                        )}
                        <Typography
                            sx={{
                                color: '#fbfaf8',
                                fontSize: '1.4rem',
                                fontFamily: "'cormorantgaramond', serif",
                                fontStyle: 'italic',
                                fontWeight: 800,
                                letterSpacing: '0.04em',
                                textRendering: 'optimizeLegibility',
                                WebkitFontSmoothing: 'antialiased'
                            }}
                        >
                            {item}
                        </Typography>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default InfiniteTicker;
